module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-431.200eb2e.woff2";